<template>


<div class="card mb-4 shadow-sm">
  <div class="card-header">
    <h4 class="my-0 font-weight-normal">{{title}}</h4>
  </div>
  <div class="card-body">
    <p class=" mt-3 mb-4" v-html="description">
      {{description}}
    </p>
    <router-link tag="button" class="btn btn-lg btn-block btn-primary" :to="({ name: 'Edit Survey', params: { id: id } })">Edit</router-link>
  </div>
</div>

</template>

<script>
  export default {
    name: 'quiz-card-bootstrap',
    props: [ 'title', 'description', 'id', 'color' ],
  }
</script>


<style scoped>
.card {
  min-width: 250px;
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizCardBootstrap.vue